// Function to handle image updates for four trays
function getImg(id, img, option, title, index) {
  const optionMappings = {
    "Tray One Box": ["#image1", "#image3", "#propertiesFourOne"],
    "Tray Two Box": ["#image2", "#image4", "#propertiesFourTwo"],
    "Tray Three Box": ["#image3", "#propertiesFourThree"],
    "Tray Four Box": ["#image4", "#propertiesFourFour"]
  };

  const [imageSelector1, imageSelector2, inputSelector] = optionMappings[option] || [];

  if (imageSelector1 && inputSelector) {
    const image1 = document.querySelector(imageSelector1);
    const image2 = imageSelector2 ? document.querySelector(imageSelector2) : null;
    const input = document.querySelector(inputSelector);

    if (image1) {
      image1.src = img;
      image1.style.opacity = "1";
    }
    if (image2) {
      image2.src = img;
      image2.style.opacity = "1";
    }
    if (input) {
      input.value = title;
    }
  }
}

// Toggle active class on click and update images
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.clickable').forEach(item => {
    item.addEventListener('click', function () {
      const group = this.getAttribute('data-group');
      
      // Find the parent product__variants container
      const parentContainer = this.closest(`.product__variants[data-group="${group}"]`);

      // Remove active class from all clickable elements in the same group
      parentContainer.querySelectorAll('.clickable').forEach(el => el.classList.remove('active'));

      // Add active class to the clicked element
      this.classList.add('active');

      // Call getImg function
      const id = this.getAttribute('data-id');
      const img = this.getAttribute('data-img');
      const option = this.getAttribute('data-option');
      const title = this.getAttribute('data-title');
      const index = this.getAttribute('data-index');
      getImg(id, img, option, title, index);
    });
  });
});
